/**
 * 将所有node_modules中组件迁移到项目内，统一为请求添加公用的UserAgent
 * @author zhenn
 * @createTime 2017-10-24
 */

const proxyUrl = {
    pro: '//proxy.upliveapps.com/index/index',
    dev: '//awsbj-proxy.xingyunzhi.cn/index/index',
    stage: '//sg-stage-proxy.upliveapp.com/index/index'
};

class PbAajx {

    constructor() {
        this.canceled = 0;
    }

    do(cfg, data, success = () => {}, timeout = () => {}, fail = () => {}) {
        let prefix = proxyUrl[this.env()];

        if (!cfg.header) {
            cfg.header = {};
        }
        // cfg.header.UserAgent = UP.Global.getGlobalUA();
        
        let _url = prefix + '?' + $.param(cfg);
        let timer, xhr;
        timer = setTimeout(function() {
            timeout();
        }, 5000);
        
        try {
            xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open("POST", _url, true);
            xhr.responseType = "arraybuffer";

            try {
                xhr.send(data.toArrayBuffer());
            } catch (e) {
                xhr.send();
            }
        } catch (e) {
            alert('please upgrade your brower, such as chrome!');
        }

        xhr.onreadystatechange = (data)=>{

            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    clearTimeout(timer);
                    if (!this.canceled) {
                        success(xhr.response);
                    }
                    
                } else {
                    if (typeof fail == 'function') {
                        fail();
                    }
                }
            }
        }
    }

    env() {
        return Uplib.url.query('env') || 'pro';
    }

    serializeURI(obj) {
        var result = [];
        if (typeof obj != 'object') {
            obj = {};
        }
        for (var i in obj) {
            result.push(i + '=' + encodeURIComponent(obj[i]));
        }

        return result.join('&')
    }

    cancel() {
        this.canceled = 1;
    }
}

export default PbAajx;


// WEBPACK FOOTER //
// ./js/component/openjs/deps/pbajax/index.js